import { Divider, Modal, Result, Steps } from "antd";
import React, { useEffect, useState } from "react";
import { $t } from "~/i18n.js";

import { SluitButton } from "~/components/buttons/SluitButton.jsx";
import { CardChecklists } from "./card.checklists.jsx";
import { CardConfirm } from "./card.confirm.jsx";
import { CardData } from "./card.data.jsx";
import { CardDay } from "./card.day.jsx";
import { CardDiensten } from "./card.diensten.jsx";
import { clubHasFlight } from "~/featureMatrix.jsx";
import { api } from "~/lib/api.js";
import { CardLists } from "./card.lists.jsx";

export const AddRoosterModal = ({
  modalVisible,
  closeModal,
  saveRooster,
  editRoosterData,
  users
}) => {
  const [step, setStep] = useState(0);
  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(true);

  const [templates, setTemplatesState] = useState([]);
  const isNew = !editRoosterData || !editRoosterData.id;

  const fetchTemplates = async () => {
    setLoading(true);
    const data = await api.get("days/day_templates.json");
    if (data) {
      setTemplatesState(
        data.map((d) => ({
          ...d,
          id: `${d.id}`,
          registration_lists: d?.registration_lists?.map((list, index) => ({
            ...list,
            id: `new_${index}`,
          })),
          roosters: d?.diensten?.map((dienst, index) => ({
            ...dienst,
            id: `new_${index}`,
          })),
          checklist_start_day: d?.checklist_start_day || [],
          checklist_end_day: d?.checklist_end_day || [],
        }))
      );
    }
    setLoading(false);
  };

  useEffect(() => {
    if (modalVisible) {
      fetchTemplates();
    }
  }, [modalVisible]);

  useEffect(() => {
    setStep(0);
    setData(
      editRoosterData?.id
        ? editRoosterData
        : {
            date_from: null,
            date_to: null,
            day: {},
            days: [],
            roosters: [],
            registration_lists: [],
            checklist_start_day: [],
            checklist_end_day: [],
            users: [],
            is_vliegend: clubHasFlight(),
          }
    );
  }, [modalVisible, editRoosterData]);

  const saveAndNext = (newData) => {
    setData({ ...data, ...newData });
    setStep(step + 1);
  };
  if (data === null) return null;

  const prev = () => setStep(step - 1);

  return (
    <Modal
      title={$t("Voeg rooster toe")}
      open={modalVisible}
      onCancel={closeModal}
      footer={null}
      width="750px"
    >
      <div style={{ padding: 24 }}>
        <Steps size="small" current={step}>
          <Steps.Step title={$t("Beschrijving")} />
          <Steps.Step title={$t("Dagen")} />
          <Steps.Step title={$t("Lijsten")} />
          <Steps.Step title={$t("Diensten")} />
          <Steps.Step title={$t("Checklists")} />
          <Steps.Step title={$t("Bevestig")} />
        </Steps>

        <Divider />

        <div className="myDataCards row" style={{ justifyContent: "center" }}>
          {step === 0 && <CardData data={data} saveAndNext={saveAndNext} loading={loading} isNew={isNew} templates={templates} />}
          {step === 1 && (
            <CardDay data={data} saveAndNext={saveAndNext} prev={prev} />
          )}


          {step === 2 && (
            <CardLists
              data={data}
              saveAndNext={saveAndNext}
              prev={prev}
            />
          )}

          {step === 3 && (
            <CardDiensten
              users={users}
              data={data}
              saveAndNext={saveAndNext}
              prev={prev}
            />
          )}

          {step === 4 && (
            <CardChecklists
              data={data}
              saveAndNext={saveAndNext}
              prev={prev}
            />
          )}

          {step === 5 && (
            <CardConfirm
              data={data}
              saveAndNext={saveAndNext}
              prev={prev}
              saveData={saveRooster}
            />
          )}
        </div>

        {step > 5 && (
          <Result
            status="success"
            title={$t("Rooster opgeslagen")}
            subTitle={$t(
              "Het rooster is opgeslagen, je kan nu de diensten invullen en het rooster activeren."
            )}
            extra={[<SluitButton key="sluit" onClick={closeModal} />]}
          />
        )}
      </div>
    </Modal>
  );
};
